module.exports = __webpack_public_path__ + "static/media/1 bundaberg rum cola hyper color realism tattoo.1280x960.a1702d38.webp";